import React, { useEffect, useState } from "react";
import { getFaqList } from "../../services/CommonService";

const Help = () => {
  const [youtube, setYoutube] = useState('');
  const [faqList, setFaqList] = useState([]);

  useEffect(() => {
    getFaqList().then((response) => {
      setYoutube(response.data.youtube);
      setFaqList(response.data.faqs);
    });
  }, []);

  return (
    <div className="help-container tab-pane fade" id="help" role="tabpanel" aria-labelledby="help-tab">
      {youtube && (
        <div className="video-wrapper">
          <iframe
            width="100%"
            height="380"
            src={youtube}
            className="video-frame"
            title="Help Video"
            allowFullScreen
          />
        </div>
      )}
      <h2 className="faq-heading">Frequently Asked Questions</h2>
      <div className="faq-accordion" id="accordionHelp">
        {faqList && faqList.map((item, index) => (
          <div className="faq-card" key={index}>
            <h2 className="faq-card-header mb-0" id={`faq${index}`}>
              <button
                className="faq-card-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#faq${index}Message`}
                aria-expanded={index === 0 ? "true" : "false"}
                aria-controls={`faq${index}Message`}
              >
                <span>{item.question}</span>
                <i className="bi bi-chevron-down toggle-icon"></i>
              </button>
            </h2>
            <div
              id={`faq${index}Message`}
              className={`faq-card-collapse collapse ${index === 0 ? "show" : ""}`}
              aria-labelledby={`faq${index}`}
              data-bs-parent="#accordionHelp"
            >
              <div className="faq-card-body">{item.answer}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Help;